import { useSelector } from 'react-redux'
import checkIcon from '../assets/checkbox_icon.svg'
import lightCheckIcon from '../assets/light_checkbox_icon.svg'
import wandIcon from '../assets/magic_wand_icon.svg'
import lightWandIcon from '../assets/light_magic_wand_icon.svg'
import lightContactBubble from '../assets/light_contact_bubble.svg'
import { defineMessages, useIntl } from 'react-intl'
import { FeatureSection } from '../../FeatureSection'
import ContactBubbleSvg from '../../../../svgs/ContactBubbleSvg'
import { selectCustomerPhotoUri } from '../../../../store/selectors/customerProfile'
import { useTheme } from '@homebot/shared-ui-swashbuckle'

import styles from './SearchFeatureSections.module.scss'

export const MSG = defineMessages({
  wandAlt: {
    id: 'HomeSearch.featureSection.wandAlt',
    defaultMessage: 'Wand icon',
  },
  insightsTitle: {
    id: 'HomeSearch.search.feature.customInsights.title',
    defaultMessage: 'Custom insights fit for your cash flow',
  },
  insightsDesc: {
    id: 'HomeSearch.search.feature.customInsights.description',
    defaultMessage:
      'Based on your budget, we crunch the numbers to help you find a home that fits your financial goals.',
  },
  expertsTitle: {
    id: 'HomeSearch.search.feature.experts.title',
    defaultMessage: 'Experts with you at every step',
  },
  expertsDesc: {
    id: 'HomeSearch.search.feature.experts.description',
    defaultMessage:
      'Without support, finding a new house can be overwhelming. Take comfort in knowing your team is with you at every step.',
  },
  checkAlt: {
    id: 'HomeSearch.featureSection.checkboxAlt',
    defaultMessage: 'Checkbox icon',
  },
  contactAlt: {
    id: 'HomeSearch.featureSection.contactAlt',
    defaultMessage: 'Contact your team',
  },
  latestTitle: {
    id: 'HomeSearch.search.feature.latest.title',
    defaultMessage: 'Get the latest homes on the market',
  },
  latestDesc: {
    id: 'HomeSearch.search.feature.latest.description',
    defaultMessage:
      'In a market this hot, keeping up with new listings is critical to you finding a home fast.',
  },
})

export const SearchFeatureSections = () => {
  const intl = useIntl()
  const { theme } = useTheme()
  const customerPhoto = useSelector(selectCustomerPhotoUri)

  return (
    <div className={styles.featureSections}>
      <FeatureSection
        className={styles.firstFeatureSection}
        title={intl.formatMessage(MSG.insightsTitle)}
        description={intl.formatMessage(MSG.insightsDesc)}
        img={
          <img
            src={theme.isLightNeutral ? lightWandIcon : wandIcon}
            alt={intl.formatMessage(MSG.wandAlt)}
          />
        }
      />
      <FeatureSection
        className={styles.secondFeatureSection}
        title={intl.formatMessage(MSG.expertsTitle)}
        img={
          theme.isLightNeutral ? (
            <img
              src={lightContactBubble}
              alt={intl.formatMessage(MSG.contactAlt)}
            />
          ) : (
            <ContactBubbleSvg photo={customerPhoto} />
          )
        }
        description={intl.formatMessage(MSG.expertsDesc)}
      />
      <FeatureSection
        className={styles.thirdFeatureSection}
        title={intl.formatMessage(MSG.latestTitle)}
        description={intl.formatMessage(MSG.latestDesc)}
        img={
          <img
            src={theme.isLightNeutral ? lightCheckIcon : checkIcon}
            alt={intl.formatMessage(MSG.checkAlt)}
          />
        }
      />
    </div>
  )
}
